import type { Carrier, CarrierApi, CarrierFilters, CarrierFiltersUpdateApi, Carriers, CarriersApi } from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeCarrier = (carrier: CarrierApi): Carrier => ({
  ...carrier,
  carrierScacCode: carrier.carrierScacCode?.trim() ?? '',
  carrierState: carrier.carrierState?.trim() ?? '',
  countryCode: carrier.countryCode?.trim() ?? '',
  id: String(carrier.id),
  label: carrier.carrierName,
  postalCode: carrier.postalCode?.trim() ?? '',
  status: carrier.status?.trim() ?? '',
});

export const normalizeCarriers = (response: CarriersApi): Carriers => {
  const list = (response.items ?? []).map(normalizeCarrier);
  return {
    list,
    map: list.reduce(
      (acc, carrier) => {
        acc[String(carrier.id)] = carrier;
        return acc;
      },
      {} as Carriers['map'],
    ),
    total: response.totalCount,
  };
};

export const normalizeCarrierFilters = (filters: Partial<CarrierFilters>): CarrierFiltersUpdateApi => {
  const { search, customerKey, carrierShortName, sorting, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch({
      ...otherFilters,
      ...(carrierShortName != null ? { carrierShortName } : {}),
      ...(customerKey !== undefined ? { customerKey } : {}),
    }),
    ...paginate(otherFilters),
    ...(sorting ? { Sorting: sorting } : {}),
  };
};
